import { observer } from "mobx-react";
import React, { useState } from "react";
import Popup from "reactjs-popup";

import { Button } from "@/components/Elements";
import ConfirmationDialog from "@/components/table/shared/ConfirmationDialog";

type ButtonWithConfirmationProp = {
  onConfirm: () => void;
  isDisabled?: boolean;
  buttonLabel: string;
  confirmationHeading: string;
  confirmationContent: string;
};

function ButtonWithConfirmation({
  isDisabled,
  onConfirm,
  buttonLabel,
  confirmationHeading,
  confirmationContent,
}: ButtonWithConfirmationProp) {
  const [showPopup, setShowPopup] = useState(false);

  const handlePopUpOpen = () => setShowPopup(true);
  const handlePopUpClose = () => setShowPopup(false);

  const onConfirmHandler = async () => {
    await onConfirm();
    handlePopUpClose();
  };

  // wrapped with div to work with react js correctly, Button does not work well with this
  const renderTrigger = (
    <div>
      <Button
        label={buttonLabel}
        onClick={handlePopUpOpen}
        theme="tertiary"
        disabled={isDisabled}
      />
    </div>
  );

  return (
    <Popup
      position="bottom left"
      trigger={renderTrigger}
      open={showPopup}
      onOpen={handlePopUpOpen}
      onClose={handlePopUpClose}
      keepTooltipInside
    >
      <div className="table-dropdown success-dropdown back-btn-confirm-popup">
        <ConfirmationDialog
          handleConfirm={onConfirmHandler}
          handleReject={handlePopUpClose}
          heading={confirmationHeading}
          content={confirmationContent}
          isConfirmDisabled={isDisabled}
        />
      </div>
    </Popup>
  );
}

export default observer(ButtonWithConfirmation);
